import { render, staticRenderFns } from "./CrudDetail.vue?vue&type=template&id=5e7d70d2&scoped=true&"
import script from "./CrudDetail.vue?vue&type=script&lang=ts&"
export * from "./CrudDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d70d2",
  null
  
)

export default component.exports